import { render, staticRenderFns } from "./fortum.vue?vue&type=template&id=4db0c149&scoped=true&"
var script = {}
import style0 from "./fortum.vue?vue&type=style&index=0&id=4db0c149&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db0c149",
  null
  
)

export default component.exports